export default function users(state = { userID: null, email: null, firstName: "", lastName: "", role: "guest", customerID: null, customerName: null, loggedIn: false, data: [], data2: [], customerList: [], folderList: [], databaseList: [], permissionsList: [], userFilter: "", userCheck: false, message: "", notes: "", currentUser: null, activationCheck: false, teamList: [], custDBList: [], custFolderList: [], ssoFail: false, ssoFlag: true}, action) {
    switch (action.type) {
        case 'LOGIN_USER':
            return { ...state, userID: action.user.id, email: action.user.userName, firstName: action.user.firstName, lastName: action.user.lastName, role: action.role, customerID: action.user.customerID, customerName: action.customerName, message: action.customerMessage, notes: action.customerNotes, loggedIn: true, ssoFail: false, ssoFlag: true, custDBList: action.custDBList, custFolderList: action.custFolderList }
        case 'LOGOUT_USER':
            return { ...state, userID: null, email: null, firstName: "", lastName: "", role: "guest", customerID: null, customerName: null, message: "", notes: "", loggedIn: false, data: [], data2: [], customerList: [], folderList: [], databaseList: [], permissionsList: [], userCheck: false, userFilter: "", teamList: [], custDBList: [], custFolderList: [], soFail: false, ssoFlag: true }
        case 'SHOW_USERS':
            return { ...state, data: action.data, data2: action.data2}
        case 'SHOW_CUSTOMERS':
            return { ...state, customerList: action.payload }
        case 'SHOW_PERMISSIONS':
            return { ...state, permissionsList: action.payload }
        case 'SHOW_TEAMS':
            return { ...state, teamList: action.payload }
        case 'SHOW_FOLDERS':
            return { ...state, folderList: action.payload }
        case 'SHOW_DATABASES':
            return { ...state, databaseList: action.payload }
        case 'LOAD_USER':
            return { ...state, currentUser: action.user}
        case 'APPLY_FILTER_USERS':
            return { ...state, userFilter: action.payload }
        case 'FLIP_USERS_SWITCH':
            return { ...state, userCheck: true }
        case 'SET_CUSTOMER_MESSAGE':
            return { ...state, message: action.message }
        case 'SET_CUSTOMER_NOTES':
            return { ...state, notes: action.notes }
        case 'ACTIVATION_CHECK':
            return { ...state, activationCheck: true }
        case 'SSO_FAIL':
            return { ...state, ssoFail: true }
        case 'SSO_FLAG':
            return { ...state, ssoFlag: false }
        default:
            return state
    }
}